import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { useSelector } from "react-redux";
import useLangTranslation from "../../../customHooks/languageProvider";

const ModalEditWebsite = ({ item, showModal, setShowModal, callFireStore }) => {
    const { getLangTranslation } = useLangTranslation();
    const [editUrl, setEditUrl] = useState(item?.websiteUrl);
    const [isDisabled, setIsDisabled] = useState(false);
    const [error, setError] = useState("");
    const { setRulesData } = useSelector(({ setRules }) => setRules);

    // Function to close the modal
    const closeModal = () => {
        setShowModal(false);
    };

    // Validate URL format
    function isValidURL(url) {
        var urlPattern =
            /^(https?|ftp):\/\/(([a-z\d]([a-z\d-]*[a-z\d])?\.)+[a-z]{2,}|localhost)(\/[-a-z\d%_.~+]*)*(\?[;&a-z\d%_.~+=-]*)?(\#[-a-z\d_]*)?$/i;
        return urlPattern.test(url);
    }

    // Check for duplicate URL
    function isDuplicateURL(url) {
        return setRulesData?.webmonitoring?.restrictedWebsite.some(
            (web) => web?.websiteUrl === url && web?.addUpdateTime !== item?.addUpdateTime
        );
    }

    function handleSubmit() {
        if (!editUrl) {
            return;
        }

        if (!isValidURL(editUrl)) {
            setError("Invalid URL");
            return;
        }

        // Allow closing the modal if the URL is unchanged
        if (editUrl === item?.websiteUrl) {
            closeModal();
            return;
        }

        if (isDuplicateURL(editUrl)) {
            setError("This URL already exists.");
            // closeModal();
            return;
        }

        setIsDisabled(true);

        const targetWebsiteToUpdate = [
            ...setRulesData?.webmonitoring?.restrictedWebsite,
        ];
        const objToModify = {
            ...targetWebsiteToUpdate?.find(
                (web) => web?.addUpdateTime === item?.addUpdateTime
            ),
        };
        const targetIndex = targetWebsiteToUpdate?.findIndex(
            (web) => web?.addUpdateTime === item?.addUpdateTime
        );

        objToModify["addUpdateTime"] = Date.now();
        objToModify["websiteUrl"] = editUrl;
        objToModify["webSiteName"] = new URL(editUrl)?.hostname;

        targetWebsiteToUpdate?.splice(targetIndex, 1, objToModify);

        const collectionPayload = {
            ...setRulesData?.webmonitoring,
            restrictedWebsite: [...targetWebsiteToUpdate],
        };

        callFireStore(collectionPayload);

        // Close the modal after the save is done
        setIsDisabled(false);
        closeModal(); // Close modal after saving
    }

    return (
        <Modal
            show={showModal}
            size="sm"
            className="custom-modal blur-bg"
            centered
        >
            <Modal.Header>
                <div className="border-0 pb-0 d-flex justify-content-between w-100">
                    <h6 className="modal-title text-blue-900">
                        {getLangTranslation("EDIT_WEBSITE", "Edit website")}
                    </h6>
                    <button
                        type="button"
                        className="btn-close"
                        data-bs-dismiss="modal"
                        aria-label="Close"
                        onClick={closeModal}
                    ></button>
                </div>
            </Modal.Header>
            <Modal.Body className="px-4">
                <div>
                    <div>
                        {getLangTranslation(
                            "WEB_MONITORING_ADD_AN_EXCEPTION_TO_BLOCK_DIALOG_ENTER_WEBSITE_URL_HINT",
                            "Enter website URL"
                        )}
                    </div>
                    <div className="input-group my-2">
                        <span
                            className="input-group-text border-end-0 fs-5 text-dark pe-0"
                            id="basic-addon3"
                        >
                            <i className="icon-globe text-gray"></i>
                        </span>
                        <input
                            type="text"
                            className="form-control border-start-0"
                            placeholder="https://www.example.com or http://www.xyz.com"
                            id="WEB_URL"
                            name="WEB_URL"
                            value={editUrl}
                            onChange={(e) => {
                                if (error) setError("");
                                setEditUrl(e.target.value);
                            }}
                        />
                    </div>
                    {error && (
                        <div className="text-start text-danger text-capitalize my-1">
                            {error}
                        </div>
                    )}
                    <div className="grid gap-3 my-4">
                        <button
                            className="btn btn-outline-primary g-col-6"
                            data-bs-dismiss="modal"
                            aria-label="Close"
                            disabled={isDisabled}
                            onClick={closeModal}
                        >
                            <span className="btn-upper-case">
                                {getLangTranslation("CANCEL", "Cancel")}
                            </span>
                        </button>
                        <button
                            className="btn btn-primary g-col-6"
                            onClick={handleSubmit}
                            disabled={isDisabled}
                        >
                            <span className="btn-upper-case">
                                {getLangTranslation("SAVE", "Save")}
                            </span>
                        </button>
                    </div>
                </div>
            </Modal.Body>
        </Modal>
    );
};

export default ModalEditWebsite;
